import UIFlex from 'UIComponents/layout/UIFlex';
import styled from '../../../utils/Styling';
const AssignmentProgressContainer = styled(UIFlex).attrs({
  align: 'stretch',
  direction: 'column',
  gap: 8
}).withConfig({
  displayName: "PlaylistAssignmentsProgressContainer__AssignmentProgressContainer",
  componentId: "z17d8u-0"
})(["width:220px !important;> div{margin:0;> div{height:12px;}}"]);
export default AssignmentProgressContainer;